const INITIAL_STATE = {
  loading: true,
  data: [],
  error: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state;
  }
}
